import { APIGet, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { IEvent } from "redux/reducers/models/event";

const apiVersion = "2024-04";
const baseUrl = "/" + apiVersion + "/guest/hospitality-event";

export interface IGetHospitalityEvent {
  id?: number;
  facility_id?: number;
  handle?: string;
  year?: number;
  month?: number;
  timeframe?: "upcoming" | "past";
  offset?: number;
  limit?: number;
  search?: string;
}

export async function GetGuestHospitalityEvent(
  params: IGetHospitalityEvent,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<IEvent>>> {
  return await APIGet(baseUrl, params, useGlobalLoader, token);
}
